/* NEXCAPE FX — Staffel-Reveal fuer Produktkarten (gated: reduced-motion + IO-Support). */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('nxfx-js');
  var io=new IntersectionObserver(function(es){
    var batch=0;
    es.forEach(function(e){
      if(!e.isIntersecting)return;
      var el=e.target;
      setTimeout(function(){el.classList.add('nxfx-in')},(batch++)*90);
      io.unobserve(el);
    });
  },{threshold:.15,rootMargin:'0px 0px -5% 0px'});
  function arm(){document.querySelectorAll('.product-item:not(.nxfx-in)').forEach(function(el){io.observe(el)})}
  arm();
  document.addEventListener('shopify:section:load',arm);
})();

/* Scroll-Zustand fuer Glas-Header (09.08. Runde 3). */
(function(){
  var on=function(){document.documentElement.classList.toggle('nxfx-scrolled',window.scrollY>24)};
  window.addEventListener('scroll',on,{passive:true});on();
})();
